import { _get, _post } from "./Axios";

export default class ProfileRSApi {
    static get(id_tweet = null) {
        return _get('/setting/rs')
    }
    static post(kata) {
        return _post('/setting/rs', kata)
    }
}